import DiagnosesTab from "./DiagnosesTab";

export default DiagnosesTab;